/**
 * 판정 기록 요약 organism — styled.
 * @spec:2026-09-29-처방검토-판정기록-조회화면
 */
import styled from "styled-components";
import { COLOR_SYSTEM } from "components/design/design-system";

export const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 12px;
  border: 1px solid ${COLOR_SYSTEM.get("Gray")?.[100]};
  border-radius: 12px;
`;

export const Total = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: ${COLOR_SYSTEM.get("Gray")?.[900]};
`;

export const GradeGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const GradeCell = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 6px 10px;
  border-radius: 8px;
  background-color: ${COLOR_SYSTEM.get("Gray")?.[50]};
  font-size: 12px;
  color: ${COLOR_SYSTEM.get("Gray")?.[700]};
`;

export const GradeCount = styled.span`
  font-size: 14px;
  font-weight: 700;
  color: ${COLOR_SYSTEM.get("Gray")?.[900]};
`;

export const RulesWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: center;
`;

export const SectionLabel = styled.div`
  font-size: 12px;
  font-weight: 700;
  color: ${COLOR_SYSTEM.get("Gray")?.[600]};
`;

export const Progress = styled.div`
  font-size: 13px;
  color: ${COLOR_SYSTEM.get("Gray")?.[700]};
`;

export const StateBox = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 20px 12px;
  color: ${COLOR_SYSTEM.get("Gray")?.[600]};
  font-size: 13px;
`;
